import { render, staticRenderFns } from "./CelulaHorariosMarcacao.vue?vue&type=template&id=1fa764d4&"
import script from "./CelulaHorariosMarcacao.vue?vue&type=script&lang=js&"
export * from "./CelulaHorariosMarcacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports